import { render } from "./setDiscountRegionFuelType.vue?vue&type=template&id=5a31a656&scoped=true"
import script from "./setDiscountRegionFuelType.vue?vue&type=script&lang=js"
export * from "./setDiscountRegionFuelType.vue?vue&type=script&lang=js"

import "./setDiscountRegionFuelType.vue?vue&type=style&index=0&id=5a31a656&lang=scss"
import "./setDiscountRegionFuelType.vue?vue&type=style&index=1&id=5a31a656&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a31a656"]])

export default __exports__